/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AprilFoolType,
    AprilFoolTypeFromJSON,
    AprilFoolTypeFromJSONTyped,
    AprilFoolTypeToJSON,
} from './AprilFoolType';

/**
 * 
 * @export
 * @interface PressReleaseV2
 */
export interface PressReleaseV2 {
    /**
     * プレスリリースID
     * @type {number}
     * @memberof PressReleaseV2
     */
    pressReleaseId: number;
    /**
     * 企業ID
     * @type {number}
     * @memberof PressReleaseV2
     */
    companyId: number;
    /**
     * 企業のロゴ画像URL
     * @type {string}
     * @memberof PressReleaseV2
     */
    companyLogoImageUrl: string | null;
    /**
     * タイトル
     * @type {string}
     * @memberof PressReleaseV2
     */
    title: string;
    /**
     * サマリー
     * @type {string}
     * @memberof PressReleaseV2
     */
    summary: string;
    /**
     * 企業名
     * @type {string}
     * @memberof PressReleaseV2
     */
    companyName: string;
    /**
     * 公開日時
     * @type {string}
     * @memberof PressReleaseV2
     */
    publishedDatetime: string;
    /**
     * 
     * @type {string}
     * @memberof PressReleaseV2
     */
    thumbnailUrl: string;
    /**
     * 
     * @type {string}
     * @memberof PressReleaseV2
     */
    pressReleaseUrl: string;
    /**
     * 
     * @type {AprilFoolType}
     * @memberof PressReleaseV2
     */
    aprilFoolType: AprilFoolType;
    /**
     * 保存済みかどうかを表すフラグ
     * @type {boolean}
     * @memberof PressReleaseV2
     */
    isBookmarked: boolean;
    /**
     * フォロー済みかを表すフラグ
     * @type {boolean}
     * @memberof PressReleaseV2
     */
    isFollowing: boolean;
}

export function PressReleaseV2FromJSON(json: any): PressReleaseV2 {
    return PressReleaseV2FromJSONTyped(json, false);
}

export function PressReleaseV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): PressReleaseV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pressReleaseId': json['press_release_id'],
        'companyId': json['company_id'],
        'companyLogoImageUrl': json['company_logo_image_url'],
        'title': json['title'],
        'summary': json['summary'],
        'companyName': json['company_name'],
        'publishedDatetime': json['published_datetime'],
        'thumbnailUrl': json['thumbnail_url'],
        'pressReleaseUrl': json['press_release_url'],
        'aprilFoolType': AprilFoolTypeFromJSON(json['april_fool_type']),
        'isBookmarked': json['is_bookmarked'],
        'isFollowing': json['is_following'],
    };
}

export function PressReleaseV2ToJSON(value?: PressReleaseV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'press_release_id': value.pressReleaseId,
        'company_id': value.companyId,
        'company_logo_image_url': value.companyLogoImageUrl,
        'title': value.title,
        'summary': value.summary,
        'company_name': value.companyName,
        'published_datetime': value.publishedDatetime,
        'thumbnail_url': value.thumbnailUrl,
        'press_release_url': value.pressReleaseUrl,
        'april_fool_type': AprilFoolTypeToJSON(value.aprilFoolType),
        'is_bookmarked': value.isBookmarked,
        'is_following': value.isFollowing,
    };
}

